import IOSInstall from "../../../../contents/docs/integrate/_snippets/install-ios.mdx";
import * as React from 'react';
export default {
  IOSInstall,
  React
};